'use memo';

import { createFileRoute, useParams } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import { OfficialDocumentsTable } from './-components/OfficialDocumentsTable';
import { isPersonOfficialDocumentTabEnabled } from './-shared/featureFlag';
export const Route = createFileRoute('/_staff/person/$id/_profile/official-documents/')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    id
  } = useParams({
    from: '/_staff/person/$id/_profile'
  });

  // タブを隠しても URL 直打ちで到達できるため、ルート側でも判定する
  if (!isPersonOfficialDocumentTabEnabled()) return <NotFound />;
  return <OfficialDocumentsTable personId={id} />;
}